import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/Login'
import Home from '../pages/Home'
import MenuSetting from '../pages/MenuSetting'
import MessageReply from '../pages/MessageReply'

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
};
Vue.use(Router);
const router = new Router({
    mode: 'hash',
    routes: [
        {
            name: 'login',
            path: '/',
            component: Login,
            meta: {
                requireAuth: false,
            }
        }, {
            name: 'home',
            path: '/home',
            component: Home,
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    name: 'setting',
                    path: 'menu/setting',
                    component: MenuSetting,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    name: 'messageReply',
                    path: 'menu/messageReply',
                    component: MessageReply,
                    meta: {
                        requireAuth: true,
                    }
                }
            ]
        },
    ]
});
router.beforeEach((to, from, next) => {
    window.console.log("from" + from.path);
    window.console.log("to" + to.path);
    window.console.log("to.meta.requireAuth" + to.meta.requireAuth);
    if (to.meta.requireAuth !== undefined && !to.meta.requireAuth) {
        window.console.log("next()");
        next();
        return;
    }
    let token = window.$cookies.get("token");
    window.console.log("token" + token);
    if (token === undefined || token === null) {
        next({
            path: '/',
            // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    } else {
        next()
    }
});
export default router;